import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { ConfigProvider } from 'antd';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { App as AntdApp } from 'antd';
import {
  clearSynqSentryUser,
  hydrateSynqSentryUserFromStorage,
  setSynqSentryUser,
} from '@admin-panel/observability';
import Layout from '../components/Layout';
import { Login, RouteProtector } from '@admin-panel/pages/synq/pages/Login';
import Products from '@admin-panel/pages/synq/pages/Products';
import Workflows from '@admin-panel/pages/synq/pages/Workflows';
import PromptTemplates from '@admin-panel/pages/synq/pages/PromptTemplates';
import StylingJobs from '@admin-panel/pages/synq/pages/StylingJobs';
import LookGroups from '@admin-panel/pages/synq/pages/LookGroups';
import Occasions from '@admin-panel/pages/synq/pages/Occasions';
import { store, persistor, useAppSelector } from '@admin-panel/pages/synq/store/store';
import { NotFoundRive } from '@admin-panel/components';

const SynqObservabilitySync = () => {
  const erpUser = useAppSelector(state => state.identity.erpUser);

  useEffect(() => {
    if (erpUser) {
      setSynqSentryUser(erpUser);
      return;
    }

    if (typeof window !== 'undefined' && localStorage.getItem('user')) {
      hydrateSynqSentryUserFromStorage();
      return;
    }

    clearSynqSentryUser();
  }, [erpUser]);

  return null;
};

export function App() {
  return (
    <BrowserRouter>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <SynqObservabilitySync />
          <ConfigProvider
            theme={{
              token: {
                // colorBorder: 'transparent',
                fontFamily: 'Hanken Grotesk',
                colorText: '#171717',
              },
              components: {
                Input: {
                  inputFontSize: 14,
                  paddingBlock: 9,
                  paddingInline: 20,
                  borderRadius: 8,
                  controlHeight: 42,
                },
                Select: {
                  selectorBg: '#F7F7F9',
                  fontSize: 14,
                  fontWeightStrong: 600,
                  borderRadius: 8,
                  controlHeight: 42,
                },
                Checkbox: {
                  colorBorder: '#171717',
                },
                Card: {
                  // @ts-expect-error this works
                  bodyPadding: '20px 16px',
                },
                Button: {
                  borderRadius: 100,
                },
                DatePicker: {
                  paddingBlock: 9,
                  paddingInline: 20,
                  borderRadius: 8,
                  controlHeight: 42,
                },
              },
            }}
          >
            <AntdApp>
              {/* <Global styles={CssReset} /> */}
              <Routes>
                <Route
                  path="*"
                  element={
                    <RouteProtector>
                      <Routes>
                        <Route path="/" element={<Layout />}>
                          <Route index element={<Products usage="TAGGING" />} />
                          <Route path="/products" element={<Products usage="TAGGING" />} />
                          <Route path="/tagging-jobs" element={<Workflows />} />

                          <Route path="/prompt-templates" element={<PromptTemplates />} />
                          <Route path="/occasions" element={<Occasions />} />

                          <Route path="/styling-jobs" element={<StylingJobs />} />
                          <Route
                            path="/styling-jobs-occasion"
                            element={
                              <StylingJobs workflowGenre="occasion" title="Occasion Styling Jobs" />
                            }
                          />
                          <Route path="/look-groups" element={<LookGroups />} />

                          <Route path="*" element={<NotFoundRive />} />
                        </Route>
                      </Routes>
                    </RouteProtector>
                  }
                />
                <Route path="/login" element={<Login />} />
              </Routes>
            </AntdApp>
          </ConfigProvider>
        </PersistGate>
      </ReduxProvider>
    </BrowserRouter>
  );
}

export default App;
